import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { lastValueFrom, map } from 'rxjs';

import { IntegrationControllerService } from 'src/app/admin-api/api/integrationController.service';
import { ProductIntegrationFailure } from 'src/app/admin-api/model/productIntegrationFailure';
import { TableColumn } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-product-integration-failure',
  templateUrl: './product-integration-failure.component.html',
  styleUrl: './product-integration-failure.component.scss'
})
export class ProductIntegrationFailureComponent implements OnInit {
  private integrationService: IntegrationControllerService = inject(
    IntegrationControllerService
  );
  private title = inject(Title);

  productIntegrationFailures: ProductIntegrationFailure[];

  cols: Array<TableColumn> = [
    new TableColumn('Nome do Produto', 'productName', true, 'text'),
    new TableColumn('SKU Millennium', 'millenniumSKU', true, 'text'),
    new TableColumn('EAN Interno', 'internalEAN', true, 'text'),
    new TableColumn('ExternalId', 'externalId', true, 'number'),
    new TableColumn('Tipo da Falha', 'failureType', true, 'text'),
    new TableColumn('Mensagem de Erro', 'errorMessage', true, 'text'),
    new TableColumn(
      'Data da Tentativa de Integração',
      'dateCreated',
      true,
      'date'
    )
  ];

  ngOnInit(): void {
    this.title.setTitle(
      'Integrações - Produtos com Falhas de Integração com o Millennium'
    );
    this.fetchProductIntegrationFailures();
  }

  async fetchProductIntegrationFailures(): Promise<void> {
    try {
      LoaderService.showLoader();
      this.productIntegrationFailures = await lastValueFrom(
        this.integrationService
          .findProductIntegrationFailures()
          .pipe(map((data) => data.result))
      );
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      LoaderService.showLoader(false);
    }
  }
}
